import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow--sprite",
  "use": "arrow--sprite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow--sprite\">\n    <circle fill=\"currentColor\" cx=\"12\" cy=\"12\" r=\"12\" opacity=\"0.65\" />\n    <path d=\"M8.7689 19.253C9.1866 19.6667 9.85962 19.6667 10.2773 19.253L17.6001 12L10.2773 4.74702C9.85962 4.3333 9.1866 4.3333 8.7689 4.74702C8.3455 5.16639 8.3455 5.8506 8.7689 6.26997L14.5541 12L8.7689 17.73C8.3455 18.1494 8.3455 18.8336 8.7689 19.253Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol